import React from 'react';
import Carousel from 'nuka-carousel';
import './Chart.css'
import Chart from "./Chart";
import ChartDenominations from "./ChartDenominations";
import ChartTransactionDay from "./ChartTransactionDay";
import ChartSlideDecorators from "./ChartSliderDecorator";

export const ChartSlider = (props) => {

    const {periodLength, salesByDate, denominationDetails, mainCurrency, salesByHour } = props;

    const options = {
        wrapAround: true,
        swiping: true,
        decorators: ChartSlideDecorators
    }

    const getComponents = (salesByDate, denominationDetails, salesByHour ) => {
        let components = [];
        for (let currency in salesByDate) {
            if (mainCurrency && mainCurrency === currency) {
                components.unshift(<Chart key={"dep"+currency} periodLength={periodLength} data={salesByDate} currency={currency}/>)
            } else {
                components.push(<Chart key={"dep"+currency} periodLength={periodLength} data={salesByDate} currency={currency}/>)
            }
        }
        for (let currency in denominationDetails) {
            if (mainCurrency && mainCurrency === currency) {
                components.unshift(<ChartDenominations key={"den"+currency} data={denominationDetails} currency={currency} />)
            } else {
                components.push(<ChartDenominations key={"den"+currency} data={denominationDetails} currency={currency} />)
            }
        }
        for (let currency in salesByHour) {
            if (mainCurrency && mainCurrency === currency) {
                components.unshift(<ChartTransactionDay key={"den"+currency} data={salesByHour} currency={currency} />)
            } else {
                components.push(<ChartTransactionDay key={"den"+currency} data={salesByHour} currency={currency} />)
            }
        }
        return components;
    };

    return(
        <Carousel {...options}>
            {getComponents(salesByDate, denominationDetails, salesByHour)}
        </Carousel>
    );
}



// WEBPACK FOOTER //
// ./src/components/chart/ChartSlider.js